import { SettingsSection } from '@components'

import { FormItemsGroup } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useInvoiceMultiCurrencyAccess } from '@features/invoices/hooks/useInvoiceMultiCurrencyAccess'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { DefaultCurrency } from './elements/DefaultCurrency'
import { DefaultLanguage } from './elements/DefaultLanguage'
import { DefaultPaymentTerm } from './elements/DefaultPaymentTerm'
import { DefaultProductType } from './elements/DefaultProductType'
import { DefaultVat } from './elements/DefaultVat'

export const GeneralSettings = (): ReactElement => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const { shouldDisplayInvoiceMultiCurrency } = useInvoiceMultiCurrencyAccess()

  const shouldShowVatSettings = !organization?.isVatExempted

  return (
    <SettingsSection.Content title={t('settings.organization.external_invoice.general.title')}>
      <FormItemsGroup>
        <DefaultProductType />
        <FormItemsGroup itemsInRow={shouldDisplayInvoiceMultiCurrency ? 2 : 1}>
          <DefaultLanguage />
          {shouldDisplayInvoiceMultiCurrency && <DefaultCurrency />}
        </FormItemsGroup>
        <DefaultPaymentTerm />
        {shouldShowVatSettings && <DefaultVat />}
      </FormItemsGroup>
    </SettingsSection.Content>
  )
}
